const productCards = document.querySelectorAll('.product-card');

// Check if the screen width is greater than 749px
const mediaQuery = window.matchMedia('(min-width: 750px)');

function handleHoverEvents() {
  // Only run the code if the media query matches (larger than 749px)
  if (mediaQuery.matches) {
    productCards.forEach((card) => {
      const editionVariantContainer = card.querySelector('.edition-variants-wrapper-holder');

      card.addEventListener('mouseover', () => {
        if (editionVariantContainer) {
          editionVariantContainer.style.display = 'flex';
        }
      });

      card.addEventListener('mouseout', () => {
        if (editionVariantContainer) {
          editionVariantContainer.style.display = 'none';
        }
      });
    });
  } else {
    // Optionally, if the window is resized smaller than 750px, remove the hover effects
    productCards.forEach((card) => {
      card.removeEventListener('mouseover', () => {});
      card.removeEventListener('mouseout', () => {});
    });
  }
}

// Run the hover event handler initially and also whenever the screen size changes
handleHoverEvents();
mediaQuery.addEventListener('change', handleHoverEvents);

document.addEventListener('DOMContentLoaded', function () {
  // Function to update the visibility of the buttons based on scroll position
  function updateButtonVisibility(wrapperHolder) {
    const sliderContainer = wrapperHolder.querySelector('.edition-variants-slider');
    const prevButton = wrapperHolder.querySelector('.prev-button');
    const nextButton = wrapperHolder.querySelector('.next-button');

    // Check if we are at the beginning or the end of the container
    if (sliderContainer.scrollLeft === 0) {
      prevButton.style.display = 'none'; // Hide the previous button if at the start
    } else {
      prevButton.style.display = 'block'; // Show the previous button
    }

    if (sliderContainer.scrollLeft + sliderContainer.clientWidth >= sliderContainer.scrollWidth) {
      nextButton.style.display = 'none'; // Hide the next button if at the end
    } else {
      nextButton.style.display = 'block'; // Show the next button
    }
  }

  // Attach event listeners to all next and previous buttons
  document.querySelectorAll('.next-button').forEach(function (nextButton) {
    nextButton.addEventListener('click', function () {
      const wrapperHolder = this.closest('.edition-variants-wrapper-holder');
      const sliderContainer = wrapperHolder.querySelector('.edition-variants-slider');
      const variantElement = wrapperHolder.querySelector('.edition-variant-wrapper');

      const elementWidth = variantElement.offsetWidth + parseFloat(getComputedStyle(variantElement).marginRight);

      // Calculate the max scrollable width to ensure we don't scroll past the last element
      const maxScrollLeft = sliderContainer.scrollWidth - sliderContainer.clientWidth;

      // Scroll by the width of one element, but stop if it exceeds the max scroll
      sliderContainer.scrollBy({
        left: Math.min(elementWidth, maxScrollLeft - sliderContainer.scrollLeft),
        behavior: 'smooth',
      });

      // Update button visibility after the scroll
      setTimeout(function () {
        updateButtonVisibility(wrapperHolder);
      }, 300); // Delay to wait for scroll animation to complete
    });
  });

  document.querySelectorAll('.prev-button').forEach(function (prevButton) {
    prevButton.addEventListener('click', function () {
      const wrapperHolder = this.closest('.edition-variants-wrapper-holder');
      const sliderContainer = wrapperHolder.querySelector('.edition-variants-slider');
      const variantElement = wrapperHolder.querySelector('.edition-variant-wrapper');

      const elementWidth = variantElement.offsetWidth + parseFloat(getComputedStyle(variantElement).marginRight);

      // Scroll by the width of one element (in reverse), but ensure we don't scroll past the first element
      sliderContainer.scrollBy({
        left: -Math.min(elementWidth, sliderContainer.scrollLeft),
        behavior: 'smooth',
      });

      // Update button visibility after the scroll
      setTimeout(function () {
        updateButtonVisibility(wrapperHolder);
      }, 300); // Delay to wait for scroll animation to complete
    });
  });

  // Initial button visibility check on page load
  document.querySelectorAll('.edition-variants-wrapper-holder').forEach(function (wrapperHolder) {
    updateButtonVisibility(wrapperHolder);
  });

  // Update button visibility when the user manually scrolls
  document.querySelectorAll('.edition-variants-slider').forEach(function (slider) {
    slider.addEventListener('scroll', function () {
      const wrapperHolder = this.closest('.edition-variants-wrapper-holder');
      updateButtonVisibility(wrapperHolder);
    });
  });
});
